import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    Grid,
    InputAdornment,
    InputLabel,
    MenuItem,
    Select,
    TextField,
} from "@material-ui/core";
import { Close } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import ReactFlagsSelect from "react-flags-select";
import { useDispatch, useSelector } from "react-redux";
import _ from "underscore";
import {
    geocodeResponseToCityState,
    IsNullOrEmpty,
    validEmail,
    validPhone,
} from "../../helpers/utility";
import {
    createDeliveryAddressRequest,
    getDeliveryAddressRequest,
} from "../../store/user/deliveryaddress/deliveryaddress.actions";
import { getDeliveryAddresses } from "../../store/user/deliveryaddress/deliveryaddress.selector";
var api_key = process.env.REACT_APP_GOOGLE_API_KEY;

const AddAddress = (props) => {
    const { onClose, onAdd } = props;
    const dispatch = useDispatch();
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [state, setCurState] = useState("");
    const [nickName, setNickName] = useState("");
    const [address, setAddress] = useState("");
    const [address1, setAddress1] = useState("");
    const [city, setCity] = useState("");
    const [cities, setCities] = useState([]);
    const [states, setStates] = useState([]);
    const [postCode, setPostCode] = useState("");
    const [isDefault, setIsDefault] = useState(true);
    const [isSeller, setIsSeller] = useState(true);
    const [status, setStatus] = useState("Active");
    const [selected, setSelected] = useState("MY");
    const [countryCode, setCountry] = useState("+60");
    const [form, setForm] = useState(false);

    const { deliveryAddresses } = useSelector((state) => {
        return {
            deliveryAddresses: getDeliveryAddresses(state),
        };
    });

    const isSellerExist = deliveryAddresses.filter((x) => {
        return x.isSeller === true;
    });

    const isDefaultExist = deliveryAddresses.filter((x) => {
        return x.isDefault === true;
    });

    const validate = () => {
        return (
            !IsNullOrEmpty(name) &&
            !IsNullOrEmpty(address) &&
            !IsNullOrEmpty(address1) &&
            !IsNullOrEmpty(city) &&
            !IsNullOrEmpty(state) &&
            !IsNullOrEmpty(postCode) &&
            !IsNullOrEmpty(phone) &&
            !IsNullOrEmpty(email)
        );
    };

    useEffect(() => {
        dispatch(getDeliveryAddressRequest());
    }, []);

    const handleSave = () => {
        if (validate()) {
            let data = {
                name: name,
                phone: countryCode + phone,
                address: address,
                subAddress: address1,
                city: city,
                isDefault: isDefaultExist.length === 0 ? true : isDefault,
                isSeller: isSellerExist.length === 0 ? true : isSeller,
                postCode: postCode,
                status: status,
                state: state,
                country: countryCode,
                nickName: IsNullOrEmpty(nickName) ? name : nickName,
                email: email,
            };

            dispatch(createDeliveryAddressRequest(data, null));
            onAdd();
        } else {
            setForm(true);
        }
    };

    const getCountryByCode = (code) => {
        if (code == "+65") return "SG";
        if (code == "+60") return "MY";
        if (code == "+1") return "US";
    };

    const handleSelect = (code) => {
        setSelected(code);
        if (code === "SG") setCountry("+65");
        if (code === "MY") setCountry("+60");
        if (code === "US") setCountry("+1");
    };

    return (
        <Dialog open={true} onClose={() => onClose()}>
            <DialogTitle>
                Add New Address
                <Close className="float-right" onClick={() => onClose()} />
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <TextField
                            fullWidth
                            label="Name"
                            placeholder="Name"
                            value={name}
                            margin="dense"
                            onChange={(e) => setName(e.target.value)}
                            variant="outlined"
                            color="primary"
                            error={form && IsNullOrEmpty(name)}
                            helperText={
                                form && IsNullOrEmpty(name)
                                    ? "Name is required"
                                    : ""
                            }
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <TextField
                            variant="outlined"
                            margin="dense"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <ReactFlagsSelect
                                            className="react-select"
                                            selected={selected}
                                            onSelect={(code) =>
                                                handleSelect(code)
                                            }
                                            countries={["MY", "SG", "US"]}
                                            customLabels={{
                                                MY: "Malaysia +60",
                                                SG: "Singapore +65",
                                                US: "United States +1",
                                            }}
                                        />
                                    </InputAdornment>
                                ),
                            }}
                            fullWidth
                            helperText={
                                form &&
                                (IsNullOrEmpty(phone) || !validPhone(phone))
                                    ? "Phone Should be valid and not empty"
                                    : ""
                            }
                            error={
                                form &&
                                (IsNullOrEmpty(phone) || !validPhone(phone))
                            }
                            label="Phone number"
                            placeholder="Phone number"
                            value={phone}
                            onChange={(e) => {
                                setPhone(e.target.value);
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <TextField
                            fullWidth
                            label="House number, Unit number"
                            placeholder="House number, Unit number"
                            onChange={(e) => setAddress(e.target.value)}
                            value={address}
                            margin="dense"
                            variant="outlined"
                            color="primary"
                            error={form && IsNullOrEmpty(address)}
                            helperText={
                                form && IsNullOrEmpty(address)
                                    ? "Address is required"
                                    : ""
                            }
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <TextField
                            fullWidth
                            label="Block/road"
                            placeholder="Block/road"
                            onChange={(e) => setAddress1(e.target.value)}
                            value={address1}
                            margin="dense"
                            variant="outlined"
                            color="primary"
                            error={form && IsNullOrEmpty(address1)}
                            helperText={
                                form && IsNullOrEmpty(address1)
                                    ? "Address1 is required"
                                    : ""
                            }
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <TextField
                            fullWidth
                            label="Postcode"
                            placeholder="Postcode"
                            margin="dense"
                            onChange={(e) => setPostCode(e.target.value)}
                            onBlur={(e) => {
                                fetch(
                                    `https://maps.googleapis.com/maps/api/geocode/json?components=country:${getCountryByCode(
                                        countryCode
                                    )}|postal_code:${postCode}&key=${api_key}`
                                )
                                    .then((response) => response.json())
                                    .then(function (response) {
                                        //parse the response for a list of matching city/state
                                        var possibleLocalities =
                                            geocodeResponseToCityState(
                                                response
                                            );
                                        if (possibleLocalities.length === 0) {
                                            setPostCode("");
                                            setStates([]);
                                            setCities([]);
                                        } else {
                                            let dat = possibleLocalities.map(
                                                (x) => {
                                                    return x.city
                                                        ? x.city
                                                        : x.state;
                                                }
                                            );
                                            setCities(_.uniq(dat));

                                            dat = possibleLocalities.map(
                                                (x) => {
                                                    return x.state
                                                        ? x.state
                                                        : x.city;
                                                }
                                            );
                                            setStates(_.uniq(dat));
                                        }
                                    });
                            }}
                            value={postCode}
                            variant="outlined"
                            color="primary"
                            error={form && IsNullOrEmpty(postCode)}
                            helperText={
                                form && IsNullOrEmpty(postCode)
                                    ? "Postcode is required"
                                    : ""
                            }
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl
                            margin="dense"
                            variant="outlined"
                            fullWidth
                        >
                            <InputLabel id="demo-simple-select-outlined-label">
                                City/ Town
                            </InputLabel>
                            <Select
                                variant="outlined"
                                fullWidth
                                label="City/ Town"
                                placeholder="City/ Town"
                                onChange={(e) => setCity(e.target.value)}
                                value={city}
                                color="primary"
                                error={form && IsNullOrEmpty(city)}
                                helperText={
                                    form && IsNullOrEmpty(city)
                                        ? "City is required"
                                        : ""
                                }
                            >
                                {cities.map((x) => {
                                    return (
                                        <MenuItem key={x} value={x}>
                                            {x}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl
                            margin="dense"
                            variant="outlined"
                            fullWidth
                        >
                            <InputLabel id="demo-simple-select-outlined-label">
                                State/ Region
                            </InputLabel>
                            <Select
                                fullWidth
                                label="State/region"
                                placeholder="State/region"
                                onChange={(e) => setCurState(e.target.value)}
                                value={state}
                                variant="outlined"
                                color="primary"
                                error={form && IsNullOrEmpty(state)}
                                helperText={
                                    form && IsNullOrEmpty(state)
                                        ? "State is required"
                                        : ""
                                }
                            >
                                {states.map((x) => {
                                    return (
                                        <MenuItem key={x} value={x}>
                                            {x}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <TextField
                            fullWidth
                            label="Email"
                            placeholder="Email"
                            margin="dense"
                            onChange={(e) => setEmail(e.target.value)}
                            value={email}
                            variant="outlined"
                            color="primary"
                            helperText={
                                form &&
                                (IsNullOrEmpty(email) || !validEmail(email))
                                    ? "Email Should be valid and not empty"
                                    : ""
                            }
                            error={
                                form &&
                                (IsNullOrEmpty(email) || !validEmail(email))
                            }
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <TextField
                            fullWidth
                            label="Save as"
                            margin="dense"
                            placeholder="Save as"
                            onChange={(e) => setNickName(e.target.value)}
                            value={nickName}
                            variant="outlined"
                            color="primary"
                        />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <div className="delivery-add mb-2">
                            <div className="flex items-center justify-between">
                                <span
                                    style={{
                                        fontWeight:
                                            isDefault === true ? 700 : 400,
                                    }}
                                >
                                    Default receiver address
                                </span>
                                <span>
                                    <input
                                        className="checkbox"
                                        disabled={isDefaultExist.length === 0}
                                        type="checkbox"
                                        checked={
                                            isDefaultExist.length === 0
                                                ? true
                                                : isDefault === true
                                        }
                                        onClick={(e) =>
                                            setIsDefault(e.target.checked)
                                        }
                                    />
                                </span>
                            </div>
                            <div className="flex items-center justify-between">
                                <span
                                    style={{
                                        fontWeight:
                                            isSeller === true ? 700 : 400,
                                    }}
                                >
                                    Default sender address
                                </span>
                                <span>
                                    <input
                                        className="checkbox"
                                        type="checkbox"
                                        disabled={isSellerExist.length === 0}
                                        checked={
                                            isSellerExist.length === 0
                                                ? true
                                                : isSeller === true
                                        }
                                        onClick={(e) => {
                                            setIsSeller(e.target.checked);
                                        }}
                                    />
                                </span>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    fullWidth
                    variant="contained"
                    color="secondary"
                    onClick={() => onClose()}
                    className="btn btn-disabled btn-small"
                >
                    Cancel
                </Button>
                <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    className="btn btn-blue-new btn-small"
                    onClick={() => handleSave()}
                >
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddAddress;
